<script setup lang="ts">
import { useOverheadImageStore } from '@/stores/overheadImageUrlsStore'
import { useZoomOverheadImage } from '@/composables/overheadImage/useZoomOverheadImage'
import IconButton from '../menu/IconButton.vue'

const overheadImageStore = useOverheadImageStore()
const zoomOverheadImage = useZoomOverheadImage()

/**
 * モーダルを閉じる
 **/
const closeModal = (): void => {
  zoomOverheadImage.close()
}
</script>

<template>
  <div v-if="zoomOverheadImage.isOpen.value">
    <div class="zoom-image-modal">
      <icon-button :icon="['fas', 'fa-square-xmark']" @click="closeModal"></icon-button>
      <img class="zoom-image" :src="overheadImageStore.zoomImage" />
    </div>
  </div>
</template>
<style scoped>
.zoom-image-modal {
  margin: 80px 0 auto;
  max-width: 80%;
  background-color: white;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  border: 1px solid #ccc;
}
.zoom-image {
  height: 80vh;
  width: 100%;
  object-fit: contain;
  padding-top: 10px;
}
</style>
